import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";

export interface Label {
  key: string;
  value: string;
}

export type Labels = Label[];

interface PatientLabelsProps {
  labels: Labels;
  setLabels: (labels: Labels) => void;
}

export const PatientLabels = ({ labels, setLabels }: PatientLabelsProps) => {
  const [hasInputValue, setHasInputValue] = useState(false);

  /* Handle add labels */
  const handleAddLabel = (e) => {
    if (e.key !== "Enter") return;

    e.preventDefault();
    const value = e.target.value;

    if (!value.trim()) return;

    const label = { key: "CLUSTER", value: value };
    setLabels([...labels, label]);
    e.target.value = "";
    setHasInputValue(false);
  };

  /**Handle delete labels */
  const handleRemoveLabel = (index) => {
    setLabels([...labels.filter((el, i) => i !== index)]);
  };

  return (
    <Row className="mb-3">
      <Col>
        <Form.Group controlId="formGridCode">
          <Form.Label>Labels</Form.Label>
          <div className="mb-1">
            {labels
              .filter((label) => label.key === "CLUSTER")
              .map((label, index) => (
                <div
                  className="d-inline-block mb-1 mx-1"
                  style={{
                    cursor: "default",
                    backgroundColor: "#e3f2fd",
                    color: "#1565c0",
                    border: "1px solid #bbccdfff",
                    padding: "2px 8px",
                    borderRadius: "4px",
                    fontSize: "0.9em",
                  }}
                  key={index}
                >
                  {label.value}
                  <button
                    className="btn btn-link py-0 ps-1 pe-0 text-decoration-none"
                    style={{ cursor: "pointer", color: "#1a4474ff" }}
                    onClick={() => handleRemoveLabel(index)}
                    aria-label={`Entferne label ${label.value}`}
                  >
                    &times;
                  </button>
                </div>
              ))}
          </div>

          <Form.Control
            type="text"
            placeholder="Fügen Sie ein Label hinzu."
            onKeyDown={handleAddLabel}
            onChange={(e) => setHasInputValue(e.target.value !== "")}
            pattern="[a-zA-Z0-9\s]+"
          />
          <Form.Text className={hasInputValue ? "visible" : "invisible"}>
            Drücken Sie <kbd>Enter</kbd>, um das Label hinzuzufügen.
          </Form.Text>
        </Form.Group>
      </Col>
    </Row>
  );
};
